import { CruiseCardShipBaseProps } from 'components/CruiseCard/CruiseCardShip/CruiseCardShip.types';
import styled from 'styled-components';
import sizes from 'styles/sizes';
import { BrandCode } from 'types';

export const CruiseCardShipBase = styled.div<CruiseCardShipBaseProps>`
	align-items: center;
	display: flex;
	gap: 8px;
	flex-wrap: wrap;
	justify-content: flex-start;
  ${({ theme }) =>
    ({
      [BrandCode.RoyalCaribbean]: `
       @media (max-width: ${sizes.media.xSmallMaxWidth}px) {
        margin-top: 5px;	
      } 
    `,
    })[theme.brandCode]}
  
	/* Cruise Card - Targets The Ratings/Reviews inside the cruise card */
	${({ className, theme }) => {
    const brandStyling = () => {
      switch (theme.brandCode) {
        case BrandCode.Celebrity:
          return `
          margin-left: 18px;

          /* @TEMP 40px - to account for Iphone 14. Temporarily solution until we have new breakpoint standards */
          @media (min-width: ${sizes.media.xSmallMaxWidth + 40}px) {
            margin-left: unset;
          }

          svg {
            width: 18px;
            height: 18px;
    
            path {
              fill: ${theme.palette.text.secondary};
            }
          }
        `;
        case BrandCode.RoyalCaribbean:
        default:
          return `
            margin-left: 21px;
            margin-top: -8px;
            margin-bottom: 8px;

          /* @TEMP 40px - to account for Iphone 14. Temporarily solution until we have new breakpoint standards */
          @media (min-width: ${sizes.media.xSmallMaxWidth + 40}px) {
            margin: unset;
          }

          svg {
            width: 20px;
            height: 20px;
    
            path {
              fill: ${theme.palette.text.primary};
            }
          }
        `;
      }
    };

    return `
    .${className}.rating {
      width: 100%;
      ${brandStyling()}

      /* 40px - to account for larger screens on newer models for Ratings Stars */
      @media (min-width: ${sizes.media.xSmallMaxWidth + 40}px) {
        width: fit-content;
      }
    }
    `;
  }}
`;

export const CruiseCardShipName = styled.h3`
	font-size: 14px;

	@media (min-width: ${sizes.media.tabletPortrait}px) {
		font-size: 16px;
	}

	${({ theme }) =>
    ({
      [BrandCode.Celebrity]: `
      color: ${theme.palette.text.secondary};
      font-family: ${theme.typography.fontFamilySemiBold};
      letter-spacing: 0.28px;
      
      text-transform: uppercase;

      @media (min-width: ${sizes.media.tabletPortrait}px) {
        letter-spacing: 0.32px;
        line-height: normal;
      }
    `,
      [BrandCode.RoyalCaribbean]: `
      color: ${theme.palette.text.primary};
      font-family: ${theme.typography.fontFamilyBold};
      font-size: 14px;
      letter-spacing: -0.28px;
      line-height: 17px;

      @media (min-width: ${sizes.media.tabletPortrait}px) {
        font-size: 16px;
        letter-spacing: -0.32px;
        line-height: 19px;
      }

      @media (min-width: ${sizes.media.mediumMaxWidth}px) {
        font-size: 18px;
        letter-spacing: -0.36px;
        line-height: 22px;
      }
    `,
    })[theme.brandCode]}
`;
